import bbitApi, { bbitApiWithoutNotification } from '@api/make-request'
import { ISickLeave } from '@app/interfaces/sick-leave'
import { AxiosResponse } from 'axios'

class SickLeaveRepository {
  reload(employeePinfl: string): Promise<unknown> {
    return bbitApi.post('employee/api/v1/sick-leave/employee/reload', {
      pinfl: employeePinfl,
    })
  }
  getEmployeeSickLeaves(
    employeePinfl: string,
  ): Promise<AxiosResponse<ISickLeave[]>> {
    return bbitApiWithoutNotification.get(
      `employee/api/v1/sick-leave/employee/${employeePinfl}`,
    )
  }
}

export default new SickLeaveRepository()
